import axios from 'axios';
import store from '../store';
import { URL as API_URL } from '../redux/api';
import { expireCompanion, showCompanionRestriction } from '../redux/companionSlice';

const client = axios.create();
client.interceptors.request.use(config => {
  const { user, companion } = store.getState();
  if (user.access || !companion.token) return config;
  const url = new URL(config.url, API_URL);
  const eventId = companion.event.id;
  const allowed =
    config.method === 'get' &&
    (url.pathname === `/api/profil/${eventId}` ||
      url.pathname === `/v2/api/evenements/${eventId}/programmes` ||
      url.pathname === `/v3/api/evenements/${eventId}/participants` ||
      url.pathname === `/v3/api/evenement/${eventId}/exposant` ||
      url.pathname.startsWith(`/api/evenement/${eventId}/exposant/`) ||
      /^\/api\/programmes\/[^/]+$/.test(url.pathname));
  if (url.pathname === '/api/configurations-pages') return config;
  if (url.origin !== new URL(API_URL).origin || !allowed) {
    store.dispatch(showCompanionRestriction('Cette fonctionnalité'));
    return Promise.reject(new axios.CanceledError('Account required'));
  }
  delete config.headers.Authorization;
  config.headers['X-Companion-Token'] = companion.token;
  config.headers['X-Companion-Session-Id'] = companion.sessionId;
  return config;
});
client.interceptors.response.use(
  response => response,
  error => {
    if (
      error.config?.headers?.['X-Companion-Token'] &&
      [401, 403].includes(error.response?.status)
    ) {
      store.dispatch(expireCompanion());
      // Existing pages must not attempt JWT refresh for guest sessions.
      return Promise.reject(new axios.CanceledError('Companion session expired'));
    }
    return Promise.reject(error);
  }
);
export default client;
